import { URL_GET_USERS_API } from 'constants/urls';

/**
 * @function getUsersApi
 * @async
 * @returns { Promise<Array> } data
 */
async function getUsersApi() {
	const options = {
		method: 'GET',
		headers: { 'Content-Type': 'application/json;charset=UTF-8' },
	};

	const res = await fetch(URL_GET_USERS_API, options);

	if (!res.ok) {
		const message = `HTTP error! status: ${res.status}`;
		throw new Error(message);
	} else {
		const data = await res.json();
		return data;
	}
}

export default getUsersApi;
